import {
  // ClientSideRowModelModule,
  ColDef,
  // ModuleRegistry,
} from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
// React Grid Logic
// import "ag-grid-enterprise/styles/ag-grid.css";
// Core CSS
// import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { useEffect, useRef, useState } from 'react';

import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { xlsxRowsToAgCols } from '~/lib/xlsx/xlsxRowsToAgCols';
// Row Data Interface

// ModuleRegistry.registerModules([ClientSideRowModelModule]);
export type GenericTableProps = {
  rows?: Record<string, string | number>[];
  loading?: boolean;
};

export const TableAgGeneric = ({ rows, loading }: GenericTableProps) => {
  const [colDefs, setColDefs] = useState<
    ColDef<Record<string, string | number>>[]
  >([{ field: 'name', headerName: 'Name' }]);
  const gridRef = useRef<AgGridReact<Record<string, string | number>>>(null);

  useEffect(() => {
    if (rows) {
      setColDefs(xlsxRowsToAgCols(rows));
    }
  }, [rows]);

  useEffect(() => {
    if (rows) {
      const defs = xlsxRowsToAgCols(rows);
      gridRef.current?.api?.setGridOption('columnDefs', defs);
    }
  }, [rows]);

  return (
    <div className="flex-column flex h-full w-full" style={{ height: '300px' }}>
      <div
        className={'ag-theme-quartz'}
        style={{ width: '100%', height: '100%' }}
      >
        <AgGridReact
          rowData={rows}
          ref={gridRef}
          loading={loading}
          suppressCellFocus
          // getMainMenuItems={getMainMenuItems}
          columnDefs={[...colDefs]}
          onGridSizeChanged={() => gridRef.current?.api.sizeColumnsToFit()}
          theme={agTheme}
          defaultColDef={{
            width: 150,
            cellClass: 'flex align-items-center',
            // cellStyle: {fontWeight: "bold"},
          }}
        />
      </div>
    </div>
  );
};
